module.exports = __webpack_public_path__ + "img/full6-min.433bcc22.png";